<template>
  <base-modal
    :reference="'emptyBus_' + bus.id"
    :title="'Vaciar el bus de todas sus reservas'"
    :acceptAction="emptyBus"
    :cancelActionText="'Cerrar'"
    :size="'md'"
  >
    <template v-slot:body v-if="show">
      
      <div class="d-block text-center">
        <p>
          Está seguro que quiere vaciar todas las reservas del bus <strong>{{bus.name}}</strong> para la operativa de <strong>{{type}}</strong>?
        </p>

      </div>
    </template>

  </base-modal>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import BaseModal from '../../../Excursions/Booking/Modal/BaseModal';

export default {
  components: {
      BaseModal,
  },
  props: {
    bus: {
      type: Object, 
      required: true,
    }
  },
  data() {
    return {
      show: false,
    }
  },
  async mounted() {
    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
      if ( modalId === 'emptyBus_' + this.bus.id ) {
        this.show = true
      }
    })
  },
  methods: {
    emptyBus() {
      let data = {
        bus_id: this.bus.id,
        bus_type: this.activeTab == 'Excursions' ? 'Excursion' : 'Pickup'
      }
      this.$store.dispatch("bookingsBus/emptyBus", data )
      this.$bvModal.hide('emptyBus_' + this.bus.id);

      this.$notify({
        group: "foo",
        title: "Bus vaciado",
        text: "Se ha vaciado el bus de reservas",
        type: "success"
      });
    },
  },
  computed: {
    ...mapGetters(["activeTab"]),
    type() {
      return this.activeTab == 'Pickups' ? 'recogidas' : 'excursiones'
    }
  }
};
</script>
